exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header[data-v-29e8c3c6] {\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 45px;\n  font-family: \"League Spartan\", sans-serif;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 32px;\n  background: #f2f3fd;\n  color: #2a2e51;\n}\n.header > div[data-v-29e8c3c6] {\n    display: flex;\n    align-items: center;\n}\nh2[data-v-29e8c3c6] {\n  margin: 0px 18px;\n}\nh3[data-v-29e8c3c6] {\n  margin: 0px 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29e8c3c6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/usr/src/app/src/assets/_include-media.scss","/usr/src/app/src/assets/palette.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header.vue
// module id = +pr7
// module chunks = 1